<div class="advice">
  <p class="advice__text">{{ adviceTest }}</p>
  <span class="advice__close" (click)="closeClick.emit()">
    <img src="assets/img/svg/close-outline.svg" alt="ícone fechar aviso">
  </span>
</div>
